<template>
  <span
    class="mt-icon mt-icon-myfonts-short"
    :class="[
      $style.myfontsShortCircle,
      hasHover ? $style.hover : ''
    ]"
  />
</template>

<script type="text/ecmascript-6">
export default {
  name: 'MyfontsShortCircle',

  props: {
    hover: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      hasHover: false
    }
  },

  created () {
    this.hasHover = this.hover
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/myfonts/variables/colors';
@import 'mpl-css/lib/assets/global/functions/index';
@import "mpl-css/lib/assets/global/icons/icons-colors";
$myfonts-short-fill: encodeHexColor(map-get($colors, 'white'));
@import "mpl-css/lib/assets/global/icons/icons-svg";
$myfontsShortIconWhite: map-get($icons, 'myfonts-short');

.myfontsShortCircle {
  background: map-get($colors, 'new-blue');
  height: rem(20);
  width: rem(20);
  border-radius: 50%;

  &:before {
    background-image: url($myfontsShortIconWhite);
    position: absolute;
    top: 20%;
    left: 20%;
    width: 60%;
    height: 60%;
  }
}

.hover {
  cursor: pointer;
  &:hover,
  &:active {
    background-color: map-get($colors, 'new-blue'); // earlier blue
  }
}
</style>
